import { h, Component } from 'preact';
import { route, Router } from 'preact-router';
import { translate } from 'react-i18next';

import Overview from './views/Overview.js';
import Security from './views/Security.js';
import Links from './views/LinkedAccounts.js';
import LinksHandler from './views/LinkedAccountsHandler.js';
import TwoFactorSettings from './views/TwoFactorSettings.js';
import TwoFactorDisable from './views/TwoFactorDisable.js';
import TwoFactorConfirm from './views/TwoFactorConfirm.js';
import VIP from './views/VIP.js';
import Email from './views/EditEmail.js';
import Other from './views/OtherSettings.js';
import ReferAFriend from './views/ReferAFriend.js';
import AddReferrer from './views/AddReferrer.js';

class ViewsWrapper extends Component {

	constructor(props) {
  	super(props);
  	this.state = {
			previousRoute: undefined,
			currentRoute: undefined,
      language: null,
      langCode: null
  	};
  }

	componentDidMount() {
		window.scrollTo(0,0);

	  const lngFromURL = this.getURLParam('lng');
    let lang;

    if (lngFromURL != null) {
      this.createCookie('language_pref', lngFromURL);
      lang = lngFromURL;
    }
    else {
      this.readCookie('language_pref') == undefined ? this.createCookie('language_pref', 'en_US', 365) : '';
      lang = this.readCookie('language_pref') != null ? this.readCookie('language_pref') : 'en_US';
    }
    if (window.location.hash === '#addreferrer') {
			route('/add-referrer', true);
		}
	}

	componentWillMount() {
    this.getLanguageCookie();
  }

	storePreviousRoute = (route) => {
		this.setState({
			previousRoute: this.state.currentRoute,
			currentRoute: route
		});
	}

	createCookie = (name, value, days) => {
		let expires;
		if (days) {
			let date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			expires = '; expires='+date.toGMTString();
		}
		else {
			expires = '';
		}
		document.cookie = name+"="+value+expires+";domain=.hirezstudios.com;path=/";
	}

	// read cookie
	readCookie = (name) => {
		let nameEQ = name + '=';
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length);
			}
		}
		return null;
	}

	getURLParam = ( name, url ) => {
		if (!url) url = location.href;
		name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
		let regexS = '[\\?&]'+name+'=([^&#]*)';
		let regex = new RegExp( regexS );
		let results = regex.exec( url );
		return results == null ? null : results[1];
	}

  getLanguageCookie = () => {
    const langCookie = this.readCookie('language_pref');
    this.setState({langCode: langCookie == undefined ? 'en_US' : langCookie});
    this.setLanguagePref(langCookie);
  }

  setLanguagePref = (lang) => {
    switch(lang) {
      case 'en_uS':
        this.setState({language: 'English'});
        break;
      case 'fr_FR':
        this.setState({language: 'Français'});
        break;
      case 'es_LA':
        this.setState({language: 'Español'});
        break;
      case 'de_DE':
        this.setState({language: 'Deutsch'});
        break;
      case 'pl_PL':
        this.setState({language: 'Polski'});
        break;
      case 'ru_RU':
        this.setState({language: 'Русский'});
        break;
      case 'tr_TR':
        this.setState({language: 'Turkish'});
        break;
      case 'pt_BR':
        this.setState({language: 'Português do Brasil'});
        break;
      case 'zh_CN':
        this.setState({language: '中国'});
        break;
      default:
        this.setState({language: 'English'});
    }
  }

  changeLanguage = (lang) => {
    this.createCookie('language_pref', lang, 365);
    // i18n.changeLanguage(lang);
    window.location = window.location.href.split('?')[0] + '?lng=' + lang;
  }

  mobileLanguageTap = () => {
    if (this.props.windowWidth < 1200) {
      this.state.langNavToggled ? this.setState( {langNavToggled: false} ) : this.setState( {langNavToggled: true} );
    }
  }

	render() {
		return (
			<main className={'views-wrapper ' + (this.state.chatActive ? 'vip-chat-active' : '')}>
        <div className={'language-wrapper ' + (this.state.langNavToggled ? 'mobile-expanded' : '') } onClick={this.mobileLanguageTap}>
          <div className="lang-select">{this.state.language && this.state.language}
            <i className="ion-android-arrow-dropdown"></i>
            <div className="languages">
              <a onClick={() => this.changeLanguage('en_US')}>English</a>
              <a onClick={() => this.changeLanguage('fr_FR')}>Français</a>
              <a onClick={() => this.changeLanguage('de_DE')}>Deutsch</a>
              <a onClick={() => this.changeLanguage('es_LA')}>Español</a>
              <a onClick={() => this.changeLanguage('pl_PL')}>Polski</a>
              <a onClick={() => this.changeLanguage('ru_RU')}>Русский</a>
              <a onClick={() => this.changeLanguage('pt_BR')}>Português do Brasil</a>
              <a onClick={() => this.changeLanguage('tr_TR')}>Turkish</a>
              <a onClick={() => this.changeLanguage('zh_CN')}>中国</a>
            </div>
          </div>
        </div>
				<Router onChange={()=>this.storePreviousRoute(window.location.pathname)}>
					<Overview default path="/" notification={this.props.notification} />
					<Security path="/security" notification={this.props.notification} />
          <Links 
            path="/linked-accounts"
            userData={this.context.userData}
          />
					<LinksHandler path="/linked-accounts/:service" webToken={this.props.webToken} />
					<TwoFactorSettings path="/two-factor" userData={this.context.userData} notification={this.props.notification} />
					<TwoFactorDisable path="/two-factor-disable" userData={this.context.userData} notification={this.props.notification} />
					<TwoFactorConfirm path="/two-factor-confirm" userData={this.context.userData} previousRoute={this.state.previousRoute} />
					<VIP path="/vip-chat" chatActive={this.props.chatActive} />
					<Email path="/edit-email" webToken={this.props.webToken} notification={this.props.notification} />
					<Other path="/other-settings" webToken={this.props.webToken} />
          <ReferAFriend path="/refer/:game" userData={this.context.userData} notification={this.props.notification} />
          <AddReferrer path="/add-referrer" userData={this.context.userData} notification={this.props.notification} />
				</Router>
			</main>
		);
	}
}

export default ViewsWrapper;



// WEBPACK FOOTER //
// ./components/ViewsWrapper.js